import React from 'react';
import Icon from '~ComponentsImproved/Icon';
import IconButton from '~ComponentsImproved/IconButton';
import { useIncomingAppOrders } from '~Providers/IncomingAppOrdersProvider';
import AppIcon from '~Assets/icons/phone_android.svg';
import useI18n from '~Translations';

const IncomingOrdersIndicator = () => {
  const { i18n } = useI18n();
  const incomingAppOrders = useIncomingAppOrders();

  // isAutoAccepting is to show it blinking a short while, sometimes it is extremely fast. If both are false we don't show the icon at all
  if (incomingAppOrders.pendingOrdersIds.length === 0 && !incomingAppOrders.isAutoAccepting) {
    return null;
  }

  return (
    <IconButton
      styles={{
        borderTop: 'none',
      }}
      icon={<Icon src={AppIcon} color="var(--colorWhite)" />}
      text={
        incomingAppOrders.isAutoAccepting
          ? i18n('App.NewIncoming')
          : incomingAppOrders.pendingOrdersIds.length + ' ' + i18n('App.PendingNew')
      }
      textColor="var(--colorWhite)"
      onClick={() => incomingAppOrders.showModal()}
      background={
        incomingAppOrders.pendingOrdersIds.length > 0 || incomingAppOrders.isAutoAccepting
          ? {
              color: 'var(--colorUIOrange)',
              blinking: true,
            }
          : undefined
      }
    />
  );
};

export default IncomingOrdersIndicator;
